<template>
  <div id="sidebar">
    <GlobalDiscountLabel></GlobalDiscountLabel>
    <div class="sidebar-header" :class="{ 's1': step == 1, 's2': step == 2, 's3': step == 3, 's4': step == 4 }">
      <a href="https://kcalmar.com/dietetyk/cennik/"><img width="120" height="120" src="../../assets/img/common/logo_pro.png" alt="" class="animate"></a>
      <div class="step-info-container">
        <p class="pink kcalmar-slogan weight-500 animate">
          Pracuj wydajniej,<br>
          zarabiaj więcej, dołącz do elity!
        </p>
        <p class="step-info">Krok {{ step }}/{{ steps }}</p>
        <div class="step-line animate"></div>
        <div class="mobile-title">{{ getMobileStepTitle }}</div>
      </div>
    </div>
    <div class="step-navbar">
      <div v-for="stepInSidebar in stepsInSidebar" :key="stepInSidebar.stepId" class="step" :class="[{'step-active': step == stepInSidebar.stepId, 'step-pass': step > stepInSidebar.stepId}, stepInSidebar.stepClass]">
        <div class="step-icon"></div>
        <p class="step-name uppercase">{{ stepInSidebar.stepName }}</p>
        <p v-if="stepInSidebar.stepId === 1" class="step-details">{{ selectedPlanName }}</p>
        <p v-if="stepInSidebar.stepId === 2" class="step-details">{{ selectedPeriodName }}</p>
        <p v-if="stepInSidebar.stepId === 3" class="step-details">Ilość dodatków: {{ selectedExtrasCount }}</p>
        <p v-if="stepInSidebar.stepId === 4" class="step-details">Zweryfikuj swoje zamówienie</p>
      </div>
    </div>
    <div class="payu">
      <a href="https://fra1.digitaloceanspaces.com/prod-kcalmar/static/files/Jak_kupowa%C4%87_na_raty_PayU.pdf" target="_blank"><img src="../../assets/img/common/payu_box.png" alt="PayU Raty"></a>
    </div>
    <div class="sum">
      <p class="uppercase">Suma do zapłaty {{ parseFloat(getTotalPrice).toFixed(2) }} PLN</p>
    </div>
    <UserInfo></UserInfo>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import GlobalDiscountLabel from '../../components/PaymentCreator/GlobalDiscountLabel'
import UserInfo from '../../components/PaymentCreator/UserInfo'

export default {
  components: {
    GlobalDiscountLabel,
    UserInfo
  },
  computed: {
    getMobileStepTitle () {
      return this.stepsInSidebar[this.step - 1].stepMobileTitle
    },
    ...mapGetters([
      'selectedPlanName',
      'selectedPeriodName',
      'selectedExtrasCount',
      'getTotalPrice'
    ]),
    ...mapState([
      'step',
      'steps',
      'summary',
      'price',
      'globalDiscountText'
    ])
  },
  data () {
    return {
      stepsInSidebar: [
        {
          stepId: 1,
          stepName: 'pakiet',
          stepClass: 'plan',
          stepMobileTitle: 'Wybierz pakiet'
        },
        {
          stepId: 2,
          stepName: 'długość planu',
          stepClass: 'duration',
          stepMobileTitle: 'Wybierz długość planu'
        },
        {
          stepId: 3,
          stepName: 'opcjonalne dodatki',
          stepClass: 'extras',
          stepMobileTitle: 'Wybierz dodatki'
        },
        {
          stepId: 4,
          stepName: 'podsumowanie',
          stepClass: 'summary',
          stepMobileTitle: 'Podsumowanie'
        }
      ]
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

#sidebar {
  width: 250px;
  left: 0;
  position: fixed;
  font-size: 13px;
  box-shadow: 0 0 3px 3px #00000014;
  z-index: 99;
  background-color: white;
  height: 100%;
  top:0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow-x: hidden;
  overflow-y: auto;
  font-family: 'Roboto-Regular';
}
.global-discount-label{
  display: none;
}
.step-navbar{
  overflow: auto;
}
.kcalmar-slogan{
  margin-top: 10px;
  margin-bottom: 20px;
}
.step-line {
  background: #e4e4e4;
  border-radius: 6px;
  height: 6px;
  margin-top: 10px;
  position: relative;
  width: 100%;
  margin-bottom: 10px;
}
.step-line:before {
  background-color: #46cda8;
  border-radius: 6px;
  content: '';
  height: 6px;
  position: absolute;
  width: 0%;
  left: 0;
  transition: all 0.3s ease-in-out;
}
.s1 .step-line:before {
  width: 25%;
}
.s2 .step-line:before {
  width: 50%;
}
.s3 .step-line:before {
  width: 75%;
}
.s4 .step-line:before {
  width: 100%;
}
.s1 #step-counter:after{
  content: '1';
}
.s2 #step-counter:after{
  content: '2';
}
.s3 #step-counter:after{
  content: '3';
}
.s4 #step-counter:after{
  content: '4';
}
.animate{
  -webkit-transition: all .3s ease-in-out;
  -moz-transition: all .3s ease-in-out;
  -o-transition: all .3s ease-in-out;
  transition: all .3s ease-in-out;
}
.sidebar-header{
  padding: 15px;
  text-align: center;
}
.step-info{
  font-size: 15px;
  font-weight: 300;
}
.step{
  padding: 10px 30px;
  padding-left: 65px;
  border-top: 1px solid #F5F5F5;
  border-bottom: 1px solid #F5F5F5;
  text-align: left;
  position: relative;
}
.step:first-child{
  border-top: 2px solid #F5F5F5;
}
.step:nth-child(5){
  border-bottom: 2px solid #F5F5F5;
}
.step-icon{
  position: absolute;
  left: 36px;
  width: 26px;
  height: 26px;
  border-radius: 25px;
}
.step-name{
  font-family: 'Roboto-Medium';
  font-weight: 500;
  color: #e6e6e6;
}
.step-details{
  color: #A8A8A8;
  display: none;
}
.step-active .step-details{
  color: #000000;
  display: block;
}
/* sidebar step pass */
.plan.step-pass .step-icon,
.duration.step-pass .step-icon,
.extras.step-pass .step-icon,
.summary.step-pass .step-icon{
  position: absolute;
  left: 36px;
  width: 26px;
  height: 26px;
  background-image: url(../../assets/img/common/icon_thick.svg);
  background-repeat: no-repeat;
  background-size: 26px;
  background-position: center;
}
.step-pass .step-name{
  color: #000;
}
.step-pass .step-details{
  display: block;
}
/* sidebar not class step-pass */
.step:not(.step-pass) .step-icon{
  width: 24px;
  height: 24px;
  border: solid 2px #e6e6e6;
}
.step:not(.step-pass) .step-icon:after{
  content: '';
  color: #e6e6e6;;
  font-weight: 500;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  font-size: 14px;
}
.step:not(.step-pass).plan .step-icon:after{
  content: '1';
}

.step:not(.step-pass).duration .step-icon:after{
  content: '2';
}

.step:not(.step-pass).extras .step-icon:after{
  content: '3';
}

.step:not(.step-pass).summary .step-icon:after{
  content: '4';
}
/* sidebar step active */
.step-navbar .step-active .step-icon{
  background-color: #41CDA8;
  border-color: #f6f6f6;
  color: #fff;
}
.step-active .step-name{
  color: #000;
}
.step-active{
  background-color: #F5F5F5;
}
.plan.step-active .step-icon:after{
  content: '1';
}
.duration.step-active .step-icon:after{
  content: '2';
}
.extras.step-active .step-icon:after{
  content: '3';
}
.summary.step-active .step-icon:after{
  content: '4';
}
/* sum */
.payu {
  margin-top: auto;
  margin-bottom: 10px;
  text-align: center;
}
.sum{;
  padding: 20px;
  background: #41CDA8;
  color: #ffffff;
  text-align: left;
  font-family: 'Roboto-Regular';
  font-weight: 700;
}
.mobile-title{
  display: none;
  color: #000000;
  font-size: 15px;
  font-weight: 500;
  font-family: 'Roboto-Medium';
  text-transform: uppercase;
  margin-top: 8px;
}
@media screen and (max-width: 768px){
  .global-discount-label{
    display: initial;
  }
  #sidebar{
    width: 100%;
    height: auto;
    max-height: max-content;
  }
  .sidebar-header {
    padding: 10px 10px;
    padding-right: 20px;
    display: flex;
  }
  .sidebar-header img{
    height: 60px;
    width: 60px;
    margin-right: 20px;
    border-right: 1px solid #e6e6e6;
  }
  .step-info-container{
    width: calc(100% - 81px);
  }
  .step-one-content .button{
    padding: 22px 20px;
  }
  .mobile-title{
    display: block;
  }
  .step-title-container > div > span:nth-child(1) {
    width: 100%;
    font-size: 23px;
  }
  .kcalmar-slogan,
  .step-navbar,
  .payu,
  .sum{
    display: none;
  }
}
</style>
